import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import CircleCheck from './CircleCheck';
import CircleInvalid from './CircleInvalid';

import styles from '../../../styles/icons/coorslight-mountain.module.scss';

const propTypes = {
    color: PropTypes.string,
    valid: PropTypes.oneOf([true, false, null]),
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    valid: null,
    className: null,
};

function CoorslightMountain({ color, valid, className }) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.valid]: valid === true,
                    [styles.invalid]: valid === false,
                    [className]: className !== null,
                },
            ])}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37.423"
                height="24.52"
                viewBox="0 0 37.423 24.52"
                className={styles.icon}
            >
                <path
                    d="M37.424,128.338,25.152,110.389l-2.633,3.85-6.44-9.421L0,128.334Z"
                    transform="translate(0 -104.818)"
                    fill={color}
                    stroke="rgba(255,255,255,0.75)"
                    strokeWidth="1"
                />
            </svg>
            {valid === true ? <CircleCheck className={styles.indicator} /> : null}
            {valid === false ? <CircleInvalid className={styles.indicator} /> : null}
        </div>
    );
}

CoorslightMountain.propTypes = propTypes;
CoorslightMountain.defaultProps = defaultProps;

export default CoorslightMountain;
